import { createContext } from "react";

const dodStemIssuer = null
const user = null
const setUser = () => {}
const apiContext = createContext({ dodStemIssuer, user, setUser });

export default apiContext;